import { ROLE } from "helper/utility";

export const SWITCH_ROLE = "Switch Roles";
export const MEMBER_PROFILE = "Member Profile";
export const DOG_PROFILE = "Dog(s) Profile";
export const HOST_PROFILE = "Host Profile";
export const PROFILE_DETAILS = "Profile Details";
export const APPLY_FOR_JUDGE = "Apply for Judge";
export const dashboardTabs = [
  MEMBER_PROFILE,
  DOG_PROFILE,
  SWITCH_ROLE,
  // APPLY_FOR_JUDGE,
];

export const dashboardTabsApproved = [
  MEMBER_PROFILE,
  DOG_PROFILE,
  SWITCH_ROLE,
];


export const judgeTabs = [PROFILE_DETAILS, SWITCH_ROLE];

export const hostTabs = [HOST_PROFILE, SWITCH_ROLE];
export const hostKey = ROLE.Host;
export const rolesForOther = [ROLE.Member, ROLE.Host];
export const rolesForAdmin = [ROLE.Member, ROLE.Host, ROLE.SuperAdmin];
export const memberKey = ROLE.memberKey;

export const adminTabs = [SWITCH_ROLE];

export const judgeUuid = "4e2bc4de-8d6d-4a65-9178-9e9e2f946a51";

export const usStatesList = [
  "Alabama - AL",
  "Alaska - AK",
  "Arizona - AZ",
  "Arkansas - AR",
  "California - CA",
  "Colorado - CO",
  "Connecticut - CT",
  "Delaware - DE",
  "Florida - FL",
  "Georgia - GA",
  "Hawaii - HI",
  "Idaho - ID",
  "Illinois - IL",
  "Indiana - IN",
  "Iowa - IA",
  "Kansas - KS",
  "Kentucky - KY",
  "Louisiana - LA",
  "Maine - ME",
  "Maryland - MD",
  "Massachusetts - MA",
  "Michigan - MI",
  "Minnesota - MN",
  "Mississippi - MS",
  "Missouri - MO",
  "Montana - MT",
  "Nebraska - NE",
  "Nevada - NV",
  "New Hampshire - NH",
  "New Jersey - NJ",
  "New Mexico - NM",
  "New York - NY",
  "North Carolina - NC",
  "North Dakota - ND",
  "Ohio - OH",
  "Oklahoma - OK",
  "Oregon - OR",
  "Pennsylvania - PA",
  "Rhode Island - RI",
  "South Carolina - SC",
  "South Dakota - SD",
  "Tennessee - TN",
  "Texas - TX",
  "Utah - UT",
  "Vermont - VT",
  "Virginia - VA",
  "Washington - WA",
  "West Virginia - WV",
  "Wisconsin - WI",
  "Wyoming - WY",
];
